<template>
  <div class="footer">
    <div class="f-body">
      <div class="fb-top">
        หากมีข้อสงสัย หรือต้องการสอบถามเพิ่มเติม ติดต่อ
        <div class="fbt-contract">
          <div class="fbtc-box">
            <img
              class="fbtcb-icon"
              src="@/assets/icons/Phone.svg"
              alt="phone-square"
            />
            <div class="phone-number">
              <div>
                <a class="link-mail" href="tel:1161">1161</a>
              </div>
            </div>
          </div>
          <div class="fbtc-box">
            <img
              class="fbtcb-icon"
              src="@/assets/icons/Email.svg"
              alt="envelope-square"
            />
            <a class="link-mail" href="mailto:email.sme@rd.go.th"
              >email.sme@rd.go.th</a
            >
          </div>
        </div>
      </div>

      <div class="fb-dash" />

      <div class="fb-bottom">
        <div style="white-space: nowrap;">
          <!-- <img src="@/assets/icons/copyright-regular 1.svg" alt="copyright" />  -->
          © 2020 The Revenue Department. All Rights Reserved.
        </div>
        <div class="term-and-condition" @click="goTermAndCondition()">
          ข้อกำหนดการใช้งาน
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  props: {
    msg: String,
  },
};
</script>

<style scoped>
.footer {
  background-color: #101820;
  color: #ffffff;
  display: flex;
  justify-content: center;
  padding-top: 32px;
  padding-bottom: 32px;
  height: 222px;
  box-sizing: border-box;
  width: 100%;
  margin: auto;
}

.f-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 350px;
  height: 100%;
  font-size: 12px;
}

.fb-top {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 284px;
}

.fbt-contract {
  display: flex;
  align-items: flex-start;
  margin-top: 8px;
  justify-content: space-around;
  width: 100%;
}

.fbtc-box {
  display: flex;
  align-items: flex-start;
}
.link-mail,
:active,
:focus {
  color: white;
  text-decoration: unset;
}
.fbtcb-icon {
  margin-right: 8px;
}

.phone-number {
  display: flex;
  flex-direction: column;
}
.or {
  display: none;
}
.fb-dash {
  width: 100%;
  height: 1px;
  border-top: 1px solid #ffffff;
  margin-top: 32px;
  margin-bottom: 32px;
}

.term-and-condition {
  cursor: pointer;
  text-align: center;
}

/*size  >768px */
@media only screen and (min-width: 769px) {
  .footer {
    height: 202px;
  }
  .f-body {
    max-width: 1120px;
  }
  .fb-top {
    max-width: 360px;
  }
  .phone-number {
    flex-direction: row;
  }
  .or {
    display: inline;
    margin: 0 5px;
  }
  .fbtc-box {
    align-items: center;
  }
}
</style>
